import React from 'react';
import Select from 'react-select';
import api from '../api';

export default class StateSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {states: []};
    }
    componentDidMount() {
        api.get('states').then(res => {
            var states = res.value;
            this.setState({
                states: Object.keys(states).map(k => states[k])
            })
        });
    }
    render () {
        var ops = this.state.states.map(state =>
                ({
                    label: state,
                    value: state
                })
        );
        return (
            <Select
                placeholder="State"
                options={ops}
                value={this.props.state}
                onChange={this.props.onChange} />
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/StateSelect.js